import React, { useEffect, useState } from 'react';
import './Footer.css';

interface FooterProps {
  onStartAnalysis?: () => void;
  canStartAnalysis?: boolean;
}

const Footer: React.FC<FooterProps> = ({ onStartAnalysis, canStartAnalysis }) => {
  const [isLoading, setIsLoading] = useState(false);

    // Listen for messages from parent window
    useEffect(() => {
      const handleMessage = (event: MessageEvent) => {
        if (event.data.type === 'CHAT_CREATE_ERROR') {
          setIsLoading(false);
          return;
        }
      };
  
      // Add event listener for messages
      window.addEventListener('message', handleMessage);
  
      // Clean up the event listener when component unmounts
      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }, []);

  const handleStartAnalysis = () => {
    if (onStartAnalysis && !isLoading) {
      setIsLoading(true);
      // Call the provided handler
      onStartAnalysis();
      
      // In a real application, you might want to reset this state when the analysis is complete
      // For now, we'll keep it in loading state after clicking
      // To simulate a real API call, you could add a setTimeout to reset the loading state
      // setTimeout(() => setIsLoading(false), 3000);
    }
  };

  console.log(isLoading,'isLoadingisLoading')
  return (
    <footer className="footer-container">
      <button 
        className="footer-action-button" 
        onClick={handleStartAnalysis} 
        disabled={!canStartAnalysis || isLoading}
      >
        {isLoading ? (
          <>
            <span className="footer-loading-spinner"></span>
            <span className="footer-action-text">Analyzing...</span>
          </>
        ) : (
          <span className="footer-action-text">Start Analysis</span>
        )}
      </button>
    </footer>
  );
};

export default Footer;
